import React from "react";
import FormComponent from "../../../../components/FormComponent/FormComponent";

const DynamicContent: React.FC<{ content: any; selectedTab: any }> = ({
  content,
  selectedTab,
}) => {
  return <FormComponent data={content.data} selectedTab={selectedTab} />;
};

export default DynamicContent;
